import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import RelativeLink from "../common/RelativeLink";
import { connect } from "react-redux";
import { formatValidatieStatussesForSideNav } from "./NavItemHelper";
import { Popup } from 'semantic-ui-react';
import { orderByPropertyName } from "../../util/orderBy";

const SideNav = ({ items, routePrefix, scope }) => {
	let windowStyle = {};
	windowStyle.left = '-12px';
	windowStyle.marginLeft = '0px';
	return (<aside className={"c-reactsidenav"}>
		{items.map((item, i) => {
			const link = item.linkEnabled ?
				item.display.length > 14 ?
					<div key={i + 1}><Popup trigger={<div className="c-reactsidenav__item truncated"><RelativeLink to={scope + "/" + routePrefix + item.url}>{item.display}</RelativeLink></div>} content={item.display} /></div>
					:
					<RelativeLink key={i + 1} className="c-reactsidenav__item truncated" to={scope + "/" + routePrefix + item.url}>{item.display}</RelativeLink>
				:
				<div className="disabled c-reactsidenav__item truncated">{item.display}</div>;
			return link;
		})}
	</aside>
	);
};

SideNav.propTypes = {
	items: PropTypes.array,
	scope: PropTypes.string,
	routePrefix: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	return {
		scope: state.layout.scope,
		items: orderByPropertyName(formatValidatieStatussesForSideNav(state.validatieStatussen), "display"),
		routePrefix: state.layout.sideNavPrefix
	};
}

export default connect(mapStateToProps)(withRouter(SideNav));
